import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const DefaultButton = ({ placement = 'top', title, icon, clickAction, clickParam, ...rest }) => {
  return (
    <OverlayTrigger placement={placement} overlay={<Tooltip>{title}</Tooltip>}>
      <Button onClick={() => clickAction(clickParam)} {...rest} >
        <FontAwesomeIcon icon={icon} />
      </Button>
    </OverlayTrigger>
  );
};

DefaultButton.propTypes = {
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired
};

export default DefaultButton;
